import { NgModule } from '@angular/core';
import { CreateLinkDirective } from '@app/pages/main/pages/quality/components/shared/editor/directives/create-link.directive';
import { CommonModule } from '@angular/common';
import { InsertLinkModalComponent } from '@app/pages/main/pages/quality/components/shared/editor/modals/insert-link-modal/insert-link-modal.component';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { InsertImageDirective } from '@app/pages/main/pages/quality/components/shared/editor/directives/insert-image.directive';

@NgModule({
  declarations: [CreateLinkDirective, InsertLinkModalComponent, InsertImageDirective],
  imports: [CommonModule, ModalModule, ReactiveFormsModule, TextBoxModule, CheckBoxModule, ButtonModule],
  exports: [CreateLinkDirective, InsertLinkModalComponent, InsertImageDirective],
})
export class EditorDirectivesModule {}
